/**
 * Medante breakpoints – single source of truth.
 * Used by JS/TS (useMediaQuery, etc.) and by component CSS (@media queries).
 * We do not override Tailwind theme.screens so parent projects keep their defaults.
 *
 * Keep in sync: m-hero-a.css, m-hero-card-a.css use these values in @media (e.g. 1101px for lg).
 *
 * Mapped from web project: sm 578px, md 768px, lg 1101px, xl 1341px, 2xl 1431px.
 */
export const BREAKPOINTS = {
	sm: '578px',
	md: '768px',
	lg: '1101px',
	xl: '1341px',
	'2xl': '1431px'
} as const

export const BREAKPOINT_VALUES = {
	sm: 578,
	md: 768,
	lg: 1101,
	xl: 1341,
	'2xl': 1431
} as const

export type BreakpointKey = keyof typeof BREAKPOINTS
